import { type Row, type RowData } from '@tanstack/react-table';

const getRawColumnValue = (row: RowData, columnId: string): unknown =>
  columnId.split('.').reduce<unknown>((value, key) => {
    if (typeof value !== 'object' || value === null) {
      return undefined;
    }

    return Reflect.get(value, key);
  }, row);

export const defaultColumnFilterFn = <T extends RowData>(
  row: Row<T>,
  columnId: string,
  filterValue: unknown
): boolean => getRawColumnValue(row.original, columnId) === filterValue;
